"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCoverImg = exports.getLuyanStatus = exports.formatHotDegree = void 0;
/**
 * 直播热度处理
*/
function formatHotDegree(num) {
    if (num == null || num == undefined || num < 0)
        return 0;
    if ((num > 0 || num == 0) && num < 10000) {
        return num;
    }
    else if ((num > 10000 || num == 10000) && num < 1000000) {
        return (num / 10000).toFixed(1) + '万';
    }
    else if (num > 1000000 || num == 1000000) {
        return "100万+";
    }
    else {
        return 0;
    }
}
exports.formatHotDegree = formatHotDegree;
;
/**
 * 通过路演状态获取html
 * @param type
 */
function getLuyanStatus(type, istest) {
    if (istest)
        return "";
    switch (type) {
        case 1:
            return "<span id=\"lystatustag\" class=\"tag zhibo\">\u76F4\u64AD\u4E2D</span>"; //<span id="lystatustag" class="tag zhibo">LIVE</span>  //直播不展示
        case 3:
            return "<span id=\"lystatustag\" class=\"tag huigu\">\u56DE\u987E</span>";
        case 4:
            return "<span id=\"lystatustag\" class=\"tag yugao\">\u9884\u544A</span>";
        default:
            return '';
    }
}
exports.getLuyanStatus = getLuyanStatus;
/**
 * 获取直播封面 h_cover > cover > v_cover
 */
function getCoverImg(data) {
    if (data === null || data === void 0 ? void 0 : data.h_cover) {
        return data.h_cover;
    }
    if (data === null || data === void 0 ? void 0 : data.cover) {
        return data.cover;
    }
    return (data === null || data === void 0 ? void 0 : data.v_cover) || "";
}
exports.getCoverImg = getCoverImg;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXRpbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJ1dGlscy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQTs7RUFFRTtBQUNGLFNBQWdCLGVBQWUsQ0FBQyxHQUFXO0lBQ3pDLElBQUksR0FBRyxJQUFJLElBQUksSUFBSSxHQUFHLElBQUksU0FBUyxJQUFJLEdBQUcsR0FBRyxDQUFDO1FBQUUsT0FBTyxDQUFDLENBQUM7SUFFekQsSUFBSSxDQUFDLEdBQUcsR0FBRyxDQUFDLElBQUksR0FBRyxJQUFJLENBQUMsQ0FBQyxJQUFJLEdBQUcsR0FBRyxLQUFLLEVBQUU7UUFDeEMsT0FBTyxHQUFHLENBQUM7S0FDWjtTQUFNLElBQUksQ0FBQyxHQUFHLEdBQUcsS0FBSyxJQUFJLEdBQUcsSUFBSSxLQUFLLENBQUMsSUFBSSxHQUFHLEdBQUcsT0FBTyxFQUFFO1FBQ3pELE9BQU8sQ0FBQyxHQUFHLEdBQUcsS0FBSyxDQUFDLENBQUMsT0FBTyxDQUFDLENBQUMsQ0FBQyxHQUFHLEdBQUcsQ0FBQztLQUN2QztTQUFNLElBQUksR0FBRyxHQUFHLE9BQU8sSUFBSSxHQUFHLElBQUksT0FBTyxFQUFFO1FBQzFDLE9BQU8sT0FBTyxDQUFBO0tBQ2Y7U0FBTTtRQUNMLE9BQU8sQ0FBQyxDQUFBO0tBQ1Q7QUFDSCxDQUFDO0FBWkQsMENBWUM7QUFBQSxDQUFDO0FBR0Y7OztHQUdHO0FBQ0gsU0FBZ0IsY0FBYyxDQUFDLElBQVksRUFBRSxNQUFlO0lBQzFELElBQUksTUFBTTtRQUFFLE9BQU8sRUFBRSxDQUFDO0lBQ3RCLFFBQVEsSUFBSSxFQUFFO1FBQ1osS0FBSyxDQUFDO1lBQ0osT0FBTyx3RUFBcUQsQ0FBQyxDQUFFLCtEQUErRDtRQUNoSSxLQUFLLENBQUM7WUFDSixPQUFPLGtFQUFvRCxDQUFDO1FBQzlELEtBQUssQ0FBQztZQUNKLE9BQU8sa0VBQW9ELENBQUM7UUFDOUQ7WUFDRSxPQUFPLEVBQUUsQ0FBQztLQUNiO0FBQ0gsQ0FBQztBQVpELHdDQVlDO0FBR0Q7O0dBRUc7QUFDSCxTQUFnQixXQUFXLENBQUMsSUFBUztJQUVuQyxJQUFJLElBQUksYUFBSixJQUFJLHVCQUFKLElBQUksQ0FBRSxPQUFPLEVBQUU7UUFDakIsT0FBTyxJQUFJLENBQUMsT0FBTyxDQUFBO0tBQ3BCO0lBRUQsSUFBSSxJQUFJLGFBQUosSUFBSSx1QkFBSixJQUFJLENBQUUsS0FBSyxFQUFFO1FBQ2YsT0FBTyxJQUFJLENBQUMsS0FBSyxDQUFBO0tBQ2xCO0lBRUQsT0FBTyxDQUFBLElBQUksYUFBSixJQUFJLHVCQUFKLElBQUksQ0FBRSxPQUFPLEtBQUksRUFBRSxDQUFBO0FBQzVCLENBQUM7QUFYRCxrQ0FXQyJ9